import $ from 'jquery'

// let ignoreStateChangeEvent = false

export function initialise() {
  $(document).on('click', 'a[data-push-state]', function (event) {
    // ignore click events when keyboard modified is being used
    if (event.metaKey || event.ctrlKey) return

    event.preventDefault()

    const $a = $(event.currentTarget)
    const url = $a.get(0).href.replace(document.location.origin, '')

    loadPage(url)

    window.history.pushState(null, document.title, url)
  })

  $(document).on('submit', 'form[data-push-state]', function (event) {
    // ignore click events when keyboard modified is being used
    // (not sure this applies to form submit)
    if (event.metaKey || event.ctrlKey) return

    event.preventDefault()

    const $form = $(event.currentTarget)
    const url = $form.attr('action') + '?' + $form.serialize()

    loadPage(url)

    window.history.pushState(null, document.title, url)
  })

  // listen for statechange (url changing)
  $(window).on('popstate', function (event) {
    const url = document.location.toString()
    // ajax request content url and update content areas
    url && loadPage(url)
  })
}

function loadPage(url) {
  $.get(url, function (response) {
    $('<div></div>')
      .append(response)
      .find('[data-push-state-target]')
      .each(function () {
        const $el = $(this)
        $('[data-push-state-target="' + $el.data('push-state-target') + '"]').replaceWith($el)
        $el.trigger('ajax.replace')
      })
  })
}

// Detect any redirects in xhr request and push onto history state if required
export function pushRedirectedState(xhr, originalUrl) {
  const url = xhr.getResponseHeader('X-Url')
  if (url && url != originalUrl) {
    // ignoreStateChangeEvent = true;
    const title = xhr.responseText.match(/<title>(.+)<\/title>/i)
    window.history.pushState(null, title ? title[1] : document.title, url)
    // TODO: does this belong here? make a config option?
    // scroll to top of page after a redirect
    window.scrollTo(0, 0)
  }
}
